import { connect } from 'react-redux';
import PassportScannerAction from '../../../legacy/React/Components/HeadingAction/Action/PassportScannerAction';
import { scan, redirect } from '../actions';
import HandleButton from '../../../legacy/React/Components/HeadingAction/Handles/HandleButton';

interface Props {
    text: Mews.TextKey;
    reservationIds?: string[];
    onScan?: $TSFixMeFunction;
    onRedirect?: $TSFixMeFunction;
}

const ScanPassportButton = ({ text, reservationIds, onScan, onRedirect }: Props) => (
    <PassportScannerAction
        action={{ text }}
        component={HandleButton}
        onScan={onScan}
        onRedirect={onRedirect}
        reservationIds={reservationIds}
    />
);

export default connect(null, {
    onScan: scan,
    onRedirect: redirect,
})(ScanPassportButton);
